<template>
  <div>
    <!-- 头部 -->
    <div class="header">
      <div class="header-inner">
        <!-- <van-icon
          name="arrow-left"
          class="left-icon"
          @click="$router.push({ name: 'index' })"
        /> -->
        <div class="right-wrap" @click="$router.push({ name: 'gamesSearch' })">
          <van-icon name="search" class="search-icon" />
          <span>请输入游戏名称</span>
        </div>
      </div>
      <van-tabs v-model="active" @change="changeTab">
        <van-tab title="选游"></van-tab>
        <van-tab title="开服列表"></van-tab>
        <van-tab title="排行"></van-tab>
      </van-tabs>
    </div>
    <div class="tab-content">
      <!-- 成交量排行 成交金额排行 -->
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="active == 0"
      >
        <game-content
          title="成交量排行"
          :otype="1"
          ref="refresh"
          @goRank="goRank(0)"
        ></game-content>
        <game-content
          title="成交额排行"
          :otype="2"
          ref="moneyRefresh"
          @goRank="goRank(1)"
        ></game-content>
      </van-pull-refresh>
      <!-- 开服列表 -->
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh2"
        v-if="active == 1"
      >
        <open-list ref="listRefresh"></open-list>
      </van-pull-refresh>
      <!-- 排行 -->
      <game-rank
        :activeindex="otype"
        @updateActiveindex="updateActiveIndex"
        v-if="active == 2"
      ></game-rank>
    </div>
  </div>
</template>

<script>
import openList from "./children/OpenList";
import gameContent from "./children/GameContent";
import gameRank from "./children/GameRank";
export default {
  components: {
    openList: openList,
    gameContent: gameContent,
    gameRank: gameRank,
  },

  data() {
    return {
      active: Number(this.$store.state.tabactive),
      isLoading: false,
      showRank: false,
      otype: Number(this.$store.state.otype),
    };
  },
  computed: {

  },
  created() {},
  mounted() {},
  methods: {
    changeTab(name,title) {
      this.$store.commit('changeTab',name)
    },
    goRank(tabIndex) {
      this.active = 2
      this.$store.commit('changeTab',2)
      if (tabIndex == 0) {
        this.otype = 0;
        this.$store.commit('changeOtype',0)
      } else if (tabIndex == 1) {
        this.otype = 1;
        this.$store.commit('changeOtype',1)
      }
    },
    //子组件传过来的修改otype的值
    updateActiveIndex(newIndex) {
      this.otype = newIndex;
      this.$store.commit('changeOtype',newIndex)
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.$refs.refresh.getRankList();
        this.$refs.moneyRefresh.getRankList();
      }, 1000);
    },
    onRefresh2() {
      setTimeout(() => {
        this.isLoading = false;
        this.$refs.listRefresh.getTagContent();
      }, 1000);
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
div {
  .header {
    width: 100%;
    background-color: #ff625a;
    height: 11rem;
    max-width: 525px;
    // position: relative;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      top: 10rem;
      width: 100%;
      height: 1.1rem;
      background-color: #f2f2f2;
      border-top-left-radius: 1rem;
      border-top-right-radius: 1rem;
    }

    .header-inner {
      display: flex;
      justify-content: space-between;
      // background: linear-gradient(33deg, #ff625a 0%, #df5f56 80%);
      background-color: #ff625a;
      height: 5rem;

      .left-icon {
        font-size: 2.7rem;
        margin: 1.4rem 1.5rem;
        color: white;
        cursor: pointer;
      }

      .right-wrap {
        flex: 1;
        height: 3rem;
        border-radius: 10rem;
        margin: 1.4rem 1.5rem;
        line-height: 3rem;
        background-color: #fff;
        color: #ccc;
        text-align: left;
        cursor: pointer;

        .search-icon {
          font-size: 1.7rem;
          margin: 0 1rem;
          vertical-align: middle;
        }
      }
    }

    .recommend {
      .content {
        margin: 0 1rem 1rem 1rem;

        img {
          width: 100%;
          height: 12rem;
          margin-bottom: 0.5rem;
        }
      }
    }

    /deep/ .van-tabs__wrap {
      height: 5rem;
    }

    /deep/.van-tab__text--ellipsis {
      // background-color: linear-gradient(33deg, #ff625a 0%, #df5f56 80%);
      color: white;
    }

    /deep/.van-tabs__nav {
      background-color: #ff625a;
      // background-color: pink;
    }

    /deep/.van-tabs__line {
      bottom: 2.3rem;
      background-color: white;
    }

    /deep/.van-tab__pane {
      position: absolute;
      z-index: 2;
      border-radius: 0.75rem 0.75rem 0 0;
    }

    /deep/.van-tab {
      font-size: 1.3rem;
    }
    /deep/.van-tab--active {
      font-size: 1.5rem;
      font-weight: 700;
    }
  }

  .tab-content {
    max-width: 525px;
    padding-top: 11rem;
  }
}
</style>
